import React from "react";

export type TopbarProps = {
  title?: string | React.ReactNode;
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  sticky?: boolean;
  className?: string;
  border?: boolean;
  heightClassName?: string; // allow override, default h-20
  align?: "left" | "center"; // layout alignment
  container?: boolean; // wrap with max-w container
};

/**
 * Topbar — title with left/right slots.
 * - Center or left alignment via align prop
 * - Optional sticky and border bottom
 */
const Topbar: React.FC<TopbarProps> = ({
  title,
  leftSlot,
  rightSlot,
  sticky = true,
  className = "",
  border = true,
  heightClassName = "h-20",
  align = "left",
  container = true,
}) => {
  return (
    <div
      className={[
        sticky ? "sticky top-0 z-10" : "",
        "w-full bg-white",
        border ? "border-b border-gray-100" : "",
        heightClassName,
        className,
      ].join(" ")}
      role="banner"
    >
      {(container ?? true) ? (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-full">
          {align === "left" ? (
            <div className="flex h-full items-center justify-start gap-2">
              {leftSlot}
              {typeof title === "string" ? (
                <h1 className="text-lg font-semibold text-blue-900">{title}</h1>
              ) : (
                title
              )}
              <div className="ml-auto flex items-center gap-2">{rightSlot}</div>
            </div>
          ) : (
            <div className="grid h-full grid-cols-[1fr_auto_1fr] items-center">
              <div className="flex items-center gap-2">{leftSlot}</div>
              <div className="flex items-center justify-center">
                {typeof title === "string" ? (
                  <h1 className="text-lg font-semibold text-blue-900">{title}</h1>
                ) : (
                  title
                )}
              </div>
              <div className="flex items-center justify-end gap-2">{rightSlot}</div>
            </div>
          )}
        </div>
      ) : (
        <div className="h-full px-0 sm:px-0 lg:px-0">
          {align === "left" ? (
            <div className="flex h-full items-center justify-start gap-2">
              {leftSlot}
              {typeof title === "string" ? (
                <h1 className="text-lg font-semibold text-blue-900">{title}</h1>
              ) : (
                title
              )}
              <div className="ml-auto flex items-center gap-2">{rightSlot}</div>
            </div>
          ) : (
            <div className="grid h-full grid-cols-[1fr_auto_1fr] items-center">
              <div className="flex items-center gap-2">{leftSlot}</div>
              <div className="flex items-center justify-center">
                {typeof title === "string" ? (
                  <h1 className="text-lg font-semibold text-blue-900">{title}</h1>
                ) : (
                  title
                )}
              </div>
              <div className="flex items-center justify-end gap-2">{rightSlot}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Topbar;
